var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 339,
    height: 276,
    viewBox: "0 0 339 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M246 185H108C104.7 185 102 182.3 102 179V81C102 77.7 104.7 75 108 75H246C249.3 75 252 77.7 252 81V179C252 182.3 249.3 185 246 185Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147 213C147 209.1 150.1 206 154 206H200C203.9 206 207 209.1 207 213",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147 213C147 209.1 150.1 206 154 206H200C203.9 206 207 209.1 207 213",
    stroke: "#5951ff",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M224 213C226.9 207.6 232.5 204 239 204C245.5 204 251.1 207.6 254 213",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M224 213C226.9 207.6 232.5 204 239 204C245.5 204 251.1 207.6 254 213",
    stroke: "#5951ff",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102 164H252V179C252 182.3 249.3 185 246 185H108C104.7 185 102 182.3 102 179V164Z",
    fill: "#8D9BFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73 129L102 174V106L88 103L73 129Z",
    fill: "#F8F8F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5013 95.6999C74.7013 90.9999 63.6013 94.1999 58.4013 103.2C53.2013 112.2 56.0013 123.4 64.5013 128.6L65.4013 129.1L84.4013 96.1999L83.5013 95.6999Z",
    fill: "#8D9BFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3047 96.1984L65.3047 129.106L70.5007 132.106L89.5007 99.1984L84.3047 96.1984Z",
    fill: "#F3F5F5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M196.797 199.9L193.997 185H159.997L158.797 191.1L196.797 199.9Z",
    fill: "#AEBCFF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M61 213V181H81V213",
    fill: "#AEBCFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81 181H61V186H81V181Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63 159L66 181",
    stroke: "#5951ff",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61 186H81",
    stroke: "#5951ff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1 157.6L72 181",
    stroke: "#5951ff",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5 169.8L77 159L73 158.8",
    stroke: "#5951ff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61 213V181H81V213",
    stroke: "#5951ff",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42 213V206H68V213",
    fill: "#8D9BFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42 213V206H68V213",
    stroke: "#5951ff",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M246 185H108C104.7 185 102 182.3 102 179V81C102 77.7 104.7 75 108 75H246C249.3 75 252 77.7 252 81V179C252 182.3 249.3 185 246 185Z",
    stroke: "#5951ff",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M194 185L198 206",
    stroke: "#5951ff",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M156 206L160 185",
    stroke: "#5951ff",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6016 153.3C34.7016 151.7 38.0016 148.8 39.0016 143C41.0016 131 31.0016 123 33.0016 111C35.0016 96.9996 49.4016 97.0996 49.4016 97.0996",
    stroke: "#5951ff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6 108.8L27.5 148.2",
    stroke: "#5951ff",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8015 96.4L58.7015 92.9C55.8015 91.2 52.2015 92.2 50.5015 95.1L47.5015 100.3C45.8015 103.2 46.8015 106.8 49.7015 108.5L55.8015 112",
    fill: "#8D9BFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8015 96.4L58.7015 92.9C55.8015 91.2 52.2015 92.2 50.5015 95.1L47.5015 100.3C45.8015 103.2 46.8015 106.8 49.7015 108.5L55.8015 112",
    stroke: "#5951ff",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2969 129.1L84.2969 96.2002",
    stroke: "#5951ff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7031 163.6L57.0031 206",
    stroke: "#5951ff",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M23 165C27.9706 165 32 160.971 32 156C32 151.029 27.9706 147 23 147C18.0294 147 14 151.029 14 156C14 160.971 18.0294 165 23 165Z",
    fill: "#8D9BFF",
    stroke: "#5951ff",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M23 160C25.2091 160 27 158.209 27 156C27 153.791 25.2091 152 23 152C20.7909 152 19 153.791 19 156C19 158.209 20.7909 160 23 160Z",
    fill: "white",
    stroke: "#5951ff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9029 165C22.9029 165 21.0029 174 27.0029 181C33.1029 188.2 43.0029 186 48.4029 206",
    stroke: "#5951ff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M177 177C178.657 177 180 175.657 180 174C180 172.343 178.657 171 177 171C175.343 171 174 172.343 174 174C174 175.657 175.343 177 177 177Z",
    fill: "white",
    stroke: "#5951ff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5013 95.7004C74.7013 90.9004 63.6013 94.2004 58.4013 103.1C53.2013 112 56.0013 123.3 64.5013 128.5L70.6013 132L89.6013 99.1004L83.5013 95.7004Z",
    stroke: "#5951ff",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M313 172H289V159C289 157.9 289.9 157 291 157H311C312.1 157 313 157.9 313 159V172Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M331 195H275C275 195 273 198 273 204C273 210 275 213 275 213H331C331 213 329 210 329 204C329 198 331 195 331 195Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M275 195H270C270 195 268 198 268 204C268 210 270 213 270 213H275C275 213 273 210 273 204C273 198 275 195 275 195Z",
    fill: "#AEBCFF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M307 187H295C291.7 187 289 184.3 289 181V172H313V181C313 184.3 310.3 187 307 187Z",
    fill: "#AEBCFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M307 187H295C291.7 187 289 184.3 289 181V159C289 157.9 289.9 157 291 157H311C312.1 157 313 157.9 313 159V181C313 184.3 310.3 187 307 187Z",
    stroke: "#5951ff",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M313 163H316C320.4 163 324 166.6 324 171C324 175.4 320.4 179 316 179H313",
    stroke: "#5951ff",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M327 187H275V195H327V187Z",
    fill: "#8D9BFF",
    stroke: "#5951ff",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M332 213H270C270 213 268 210 268 204C268 198 270 195 270 195H332",
    stroke: "#5951ff",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M331 213C331 213 329 210 329 204C329 198 331 195 331 195",
    stroke: "#5951ff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M275 213C275 213 273 210 273 204C273 198 275 195 275 195",
    stroke: "#5951ff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M329.2 201H305",
    stroke: "#5951ff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M329 205H315",
    stroke: "#5951ff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M300.195 150C300.195 150 300.795 149.5 301.395 148.4",
    stroke: "#5951ff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M302.898 142.9C302.898 142.6 302.898 142.3 302.898 142C302.898 136.4 298.898 133.7 298.898 129.9C298.898 129 298.998 128.1 299.298 127.3",
    stroke: "#5951ff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.86 3.86"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M300.398 124.6C300.998 123.6 301.498 123 301.498 123",
    stroke: "#5951ff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M102 164H252",
    stroke: "#5951ff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2031 153.2L25.8031 158.8",
    stroke: "#5951ff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M22 213H332",
    stroke: "#5951ff",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(130.02 71.69) scale(0.18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.381 215.117C181.381 234.934 165.316 250.998 145.499 250.998C125.682 250.998 109.617 234.934 109.617 215.117C109.617 195.3 125.682 179.235 145.499 179.235C165.316 179.235 181.381 195.3 181.381 215.117Z",
    fill: "#5951ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.875 215.116C315.875 234.933 299.81 250.998 279.993 250.998C260.176 250.998 244.111 234.933 244.111 215.116C244.111 195.299 260.176 179.234 279.993 179.234C299.81 179.234 315.875 195.299 315.875 215.116Z",
    fill: "#5951ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.875 335.457C292.711 366.069 378.738 318.397 404.147 290.734",
    stroke: "#5951ff",
    strokeWidth: 21,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImage);
export default __webpack_public_path__ + "static/media/login-image.6f9a7cecfc1b587390cd4f3285e8c4ea.svg";
export { ForwardRef as ReactComponent };